
import { defineComponent, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { dispatchError } from "../../../utils/error_handling";
import { wrapLoading } from "../../../utils/wrap_loading";
import BarChart from "../charts/BarChart.vue";
import {UserAccess} from "../../../../../domain/entities/entities";

export default defineComponent({
  name: "AccessesStatistics",
  components: { BarChart },
  setup() {
    const store = useStore();

    const loadUserAccesses = async () => {
      try {
        await store.dispatch("userProfile_module/loadUserAccesses");
      } catch (e) {
        await dispatchError(e);
      }
    };

    const userAccesses = computed<UserAccess[]>(
        () => store.getters["userProfile_module/userAccesses"]
    );

    const chartData = computed(() => {
      if (!userAccesses.value || userAccesses.value.length === 0) {
        return {
          labels: [],
          currentWeek: [],
          previousWeek: [],
          previousWeekLabels: [],
        };
      }

      const accesses = userAccesses.value;

      const total = accesses.length;
      const middle = Math.floor(total / 2);

      const previous7Days = accesses.slice(0, middle);
      const last7Days = accesses.slice(middle);

      return {
        labels: last7Days.map((a) => a.period),
        currentWeek: last7Days.map((a) => a.quantity),
        previousWeek: previous7Days.map((a) => a.quantity),
        previousWeekLabels: previous7Days.map((a) => a.period),
      };
    });

    onMounted(async () => {
      await wrapLoading(loadUserAccesses);
    });

    return {
      chartData,
    };
  },
});
